import request from "@/router/request";

//创建订单
export const CreateOrder = (data) => {
    return request({
        url: '/api/Order/CreateOrder',
        method: "post",
        data: data
    });
}
//获取H5支付地址
export const getPayInfo = (billNo) => {
    return request({
        url: '/api/Order/GetPayInfoH5Url',
        method: "get",
        params: {
            billNo
        }
    });
}//查询支付结果
export const queryPay = (billNo) => {
    return request({
        url: '/api/Order/QueryPayResult',
        method: "get",
        params: {
            billNo
        }
    });
}
//支付确认
export const PayConfirm = (data) => {
    return request({
        url: '/api/Order/PayConfirm',
        method: "post",
        data: data
    });
}

//订单确认
export const ConfirmOrder = (data) => {
    return request({
        url: '/api/Order/ConfirmOrder',
        method: "post",
        data: data
    });
}
export const getPayTypeName = (payType) => {
    let val = "";
    switch (payType) {
        case "AliPay":
            val = "支付宝";
            break;
        case "WechatPay":
            val = "微信";
            break;
    }
    return val;
}
export const getBusTypeName = (busType) => {
    let val = "";
    switch (busType) {
        case "WaterRecharge":
          val = "水费充值";
          break;
        case "Register":
          val = "当日挂号";
          break;
        case "ReserveRegister":
          val = "预约挂号";
          break;
      }
    return val;
}